// extracted by css-extract-rspack-plugin
export default {"loaderOverlay":"qSctA0bJ"};